/**
 * The Module Federation async boundary. This file exists to be almost empty.
 *
 * MF initialises shared modules (ARC-10) asynchronously. If the entry
 * chunk imports a shared singleton synchronously — `react`, `react-dom`, or
 * any @serckl/* package — the runtime has not finished negotiating versions
 * when that import is evaluated, and `loadShareSync` throws
 * RUNTIME-006 before a single line of application code runs.
 *
 * The dynamic import below is what defers everything past that point. Keep this
 * file free of static imports; put new bootstrap work in bootstrap.tsx.
 */
void import('./bootstrap.tsx');
